import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import ToggleTextLegacy, { type ToggleTextProps } from './toggleText-legacy'

const ToggleTextDS = dynamic(() =>
  import(/* webpackChunkName: "toggle-text-ds" */ '@src/components/blocks/toggle-text-ds').then(m => ({
    default: m.ToggleTextDS,
  })),
)

const ToggleText = (props: ToggleTextProps) => {
  if (shouldUseDesignSystem()) {
    return <ToggleTextDS {...props} />
  }
  return <ToggleTextLegacy {...props} />
}

export type { ToggleTextProps }
export default ToggleText
